import React, {useEffect, useState} from 'react';
import { useParams } from 'react-router';
import Steps from "../../../components/steps/steps";
import styles from './registration-form.module.scss';
import {Row, Col} from 'react-bootstrap';
import Loading from "../../../components/loading/loading";
import Registration from "../../../models/registration";
import SecondaryMarketService from "../../../services/secondary-market-service";
import InvestorDetails from "./components/investor-details/investor-details";
import ContactDetails from "./components/contact-details/contact-details";
import WorkBankDetails from "./components/work-bank-details/work-bank-details";
import RegistrationConfirmation from "./components/registration-confirmation/registration-confirmation";
import RegistrationSubmitted from "./components/registration-submitted/registration-submitted";

const RegistrationForm = () => {
  //Investor Registration Form Steps
  const keys = [
    { id: 'investorDetails', name: 'INVESTOR DETAILS' },
    { id: 'contactDetails', name: 'CONTACT DETAILS'  },
    { id: 'workDetails', name: 'WORK AND BANK DETAILS' },
    { id: 'confirmation', name: 'CONFIRMATION'},
    { id: 'registrationSubmitted', name: 'SUBMITTED'}
  ]
  //Retrieve security id from params
  const { registrationId }  = useParams();
  //Main Trade Form state
  const [ loading, setLoading ] = useState(true);
  const [ registrationFormState, setRegistrationFormState ] = useState(new Registration());
  const [ initialRegistrationInfoState, setInitialRegistrationInfoState ] = useState({});

  const secondaryMarketService = new SecondaryMarketService();

  //Proceed to next step or back 1 step
  const [ activeTabIndex, setActiveTabIndex ] = useState(0);

  useEffect(() => {
    const getInitialRegistrationInformation = async () => {
      try {
        const initialRegistrationInfo = await secondaryMarketService.getRegistration(registrationId);
        setInitialRegistrationInfoState(initialRegistrationInfo);
      } catch(error){
        //show appropriate page
      } finally {
        setLoading(false);
      }
    }
    getInitialRegistrationInformation();
  }, []);
  const next = () => {
    if( activeTabIndex <= keys.length ){
      setActiveTabIndex(activeTabIndex + 1);
      window.scrollTo({top: 0});
    }
  }
  const back = () => {
    if( back && activeTabIndex > 0 ){
      setActiveTabIndex( activeTabIndex - 1 );
      window.scrollTo({top: 0});
    }
  }


  //Render trade transfer form sections
  const renderSection = () => {
    switch( keys[activeTabIndex].id ) {
      case 'investorDetails':
        return <InvestorDetails context={{initialRegistrationInfoState, registrationFormState, setRegistrationFormState}} controls={{next}}/>
      case 'contactDetails':
        return <ContactDetails context={{initialRegistrationInfoState, registrationFormState, setRegistrationFormState}} controls={{next, back}}/>
      case 'workDetails':
        return <WorkBankDetails context={{initialRegistrationInfoState, registrationFormState, setRegistrationFormState}} controls={{next, back}}/>
      case 'confirmation':
        return <RegistrationConfirmation context={{initialRegistrationInfoState, registrationFormState, setRegistrationFormState}} controls={{next, back}}/>
      case 'registrationSubmitted':
        return <RegistrationSubmitted />
      default:
    }
  }
  return loading ? <Loading /> : (
    <div>
      <Row>
        <Col lg={{offset: 2, span: 8}}>
          <Steps activeKeyIndex={activeTabIndex} keys={keys}/>
          {renderSection()}
        </Col>
      </Row>
    </div>
  )

}

export default RegistrationForm;
